import { MouseEvent, ReactElement } from 'react'
import { Stack } from '@mui/material'
import { IfcTypeItem } from '@editor/components/Controls/IFCUploadWidget/components/IFCFileConfig/IfcTypeItem'
import { storeyToLabel } from '@editor/pages/Plans/components/AddPlanDialog/components/utils'

export interface StoreyColorLegendItem {
  storey: string
  color: string
  visible: boolean
  onToggleVisibility: () => void
  /** Receives the click event so callers can extend the selection on shift-click. */
  onClickSelect: (event: MouseEvent<HTMLButtonElement>) => void
}

interface Props {
  items: StoreyColorLegendItem[]
}

/**
 * Config/legend for the IFC storey coloring: one row per storey showing its label, color swatch,
 * and (like the IFC type-coloring config) a visibility toggle and a select button.
 */
const IFCStoreyColorLegend = ({ items }: Props): ReactElement => (
  <Stack spacing={0.5}>
    {items.map(item => (
      <IfcTypeItem
        key={item.storey}
        title={storeyToLabel(item.storey)}
        bgColor={item.color}
        visible={item.visible}
        onToggleVisibility={item.onToggleVisibility}
        onClickSelect={item.onClickSelect}
      />
    ))}
  </Stack>
)

export default IFCStoreyColorLegend
